import React, { FC } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button } from '@pandiafi/design-system'

import { DefectNoticeListItem } from '../../../common/validations/defectNotice'
import { renderEventType } from '../../views/DefectNotice/utils'
import { useContractPaths } from '../../hooks/useContractPaths/useContractPaths'

export const DefectNoticeCard: FC<{
  defectNotice: DefectNoticeListItem
}> = ({ defectNotice }) => {
  const { t } = useTranslation(['defectNotice'])
  const { defectNoticeEditPath } = useContractPaths()
  const navigate = useNavigate()

  const title = defectNotice.title || defectNotice.description

  function navigateToNotice() {
    navigate(
      defectNoticeEditPath.replace(':defectNoticeUuid', defectNotice.uuid)
    )
  }

  return (
    <div
      onClick={() => navigateToNotice()}
      className={classNames(
        'min-h-16 min-w-80 p-3 rounded-md bg-common-blue-2 relative text-common-gray-7 cursor-pointer hover:bg-common-blue-3'
      )}
      style={
        {
          '--button-secondary-border-color': 'transparent',
        } as React.CSSProperties
      }
    >
      <div>
        <div className={classNames('flex justify-between')}>
          <div>
            <div className={classNames('font-medium text-sm')}>
              <div>
                {t('texts.list.title')} #{defectNotice.id}
                {title ? ':' : ''}
              </div>
              {title && (
                <div
                  style={{ overflowWrap: 'anywhere', paddingRight: '0.5rem' }}
                >
                  {title}
                </div>
              )}
            </div>
            <div className={classNames('text-sm')}>
              {renderEventType(defectNotice.latestEvent)}
            </div>
          </div>
          <div className={classNames('flex justify-end')}>
            <Button
              icon="angle-right"
              iconPosition="right"
              onClick={() => navigateToNotice()}
              variant="secondary"
              small
              circle
            />
          </div>
        </div>
      </div>
    </div>
  )
}
